import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "map-header" }
const _hoisted_2 = {
  key: 0,
  class: "map-header__tabs-wrapper"
}
const _hoisted_3 = {
  key: 1,
  class: "map-header__back"
}
const _hoisted_4 = {
  key: 2,
  class: "status-list"
}
const _hoisted_5 = { class: "status-list__item-text" }
const _hoisted_6 = {
  key: 3,
  class: "map-header__filter"
}

import { computed } from 'vue';
import CustomListButton from '@/components/commons/CustomControls/CustomListButton.vue';
import CustomButtonBack from '@/components/commons/CustomControls/CustomButtonBack.vue';
import ContainerCustom from '../layouts/ContainerCustom.vue';
import { landPlotStore } from '@/store/modules/LandPLot';
import { cardSettingsStore } from '@/store/modules/CardSettings';
import { MOBILE_TOP } from '@/constants/sizes';


export default /*@__PURE__*/_defineComponent({
  __name: 'MapHeader',
  emits: ['openFilter', 'openList', 'changeTab'],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const statusList: Array<{
    id: number;
    text: string;
    status: string;
    color: string;
}> = [
        {
            id: 0,
            text: 'Свободен',
            status: 'success',
            color: '#2BB673',
        },
        {
            id: 1,
            text: 'Забронирован',
            status: 'warning',
            color: '#B9C449',
        },
        {
            id: 2,
            text: 'Занят',
            status: 'danger',
            color: '#D82D2D',
        },
    ];

const isShowInfoForDetailSection = computed(() => {
    return landPlotStore.CURRENT_SECTION_ZONE ? true : false;
});

function backToFullMap() {
    landPlotStore.SET_CURRENT_SECTION_ZONE('');
}

function openList() {
    emits('openList');
}

function onUploadSchemeImage() {
    // const urlFromOtherDomain = `http${
    //     process.env.VUE_APP_COMPONENT_SECURE === 'true' ? 's' : ''
    // }://${process.env.VUE_APP_COMPONENT_DOMAIN}/uploads/scheme_2D.jpg`;
    const urlFromOtherDomain = `http${
        process.env.VUE_APP_COMPONENT_SECURE === 'true' ? 's' : ''
    }://${process.env.VUE_APP_COMPONENT_DOMAIN}/uploads/scheme_2D.jpg`;

    fetch(urlFromOtherDomain)
        .then(res => res.blob())
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            document.body.appendChild(link);
            link.setAttribute('download', 'scheme_2D');
            link.href = url;
            link.click();
            document.body.removeChild(link);
        });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isShowInfoForDetailSection.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "map-header__download-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onUploadSchemeImage()))
        }, _toDisplayString(_unref(cardSettingsStore).MAP_DOM_RECT.width <= _unref(MOBILE_TOP)
          ? 'Скачать схему'
          : 'Скачать 2D схему'), 1))
      : _createCommentVNode("", true),
    _createVNode(ContainerCustom, { class: "map-header__container" }, {
      default: _withCtx(() => [
        (!isShowInfoForDetailSection.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        (isShowInfoForDetailSection.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(CustomButtonBack, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (backToFullMap())),
                class: "map-header__back-btn"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Все дома ")
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (isShowInfoForDetailSection.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, (item) => {
                return _createElementVNode("li", {
                  key: item.id,
                  class: _normalizeClass(["status-list__item", `status-list__item-${item.status}`])
                }, [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ backgroundColor: item.color }),
                    class: "status-list__item-circle"
                  }, null, 4),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(item.text), 1)
                ], 2)
              }), 64))
            ]))
          : _createCommentVNode("", true),
        (isShowInfoForDetailSection.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(CustomListButton, {
                class: "map-header__filter-list",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (openList()))
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Список")
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})